import { createFileRoute, redirect } from "@tanstack/react-router"

import { PageContent } from "@/components/common/page-content"
import { PageHeader } from "@/components/common/page-header"
import { HomeChanged } from "@/features/home/components/home-changed"
import { HomeComingUp } from "@/features/home/components/home-coming-up"
import { HomeCompliance } from "@/features/home/components/home-compliance"
import { HomeRisk } from "@/features/home/components/home-risk"
import { HomeToDo } from "@/features/home/components/home-to-do"
import { organisationPath } from "@/lib/organisation-path"
import { homeQueries } from "@/queries/home"

const homePath = "/dashboard"

export const Route = createFileRoute(
  "/$organisation/_authenticated/_organisation/_main/dashboard/"
)({
  beforeLoad: ({ context, params }) => {
    if (context.organisation.home !== homePath) {
      throw redirect({
        to: organisationPath(context.organisation.home),
        params: { organisation: params.organisation },
      })
    }
  },
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(homeQueries.show()),
  component: HomePage,
})

function HomePage() {
  return (
    <>
      <PageHeader title="Home" />
      <PageContent>
        <HomeRisk />
        <HomeToDo />
        <HomeCompliance />
        <HomeChanged />
        <HomeComingUp />
      </PageContent>
    </>
  )
}
